import React from 'react'
import styles from './DSWizardHelper.scss'
import CreatableSelect from 'react-select/lib/Creatable'
import ReactSelect2, {components as reactSelectComponents} from 'react-select'
import cs from 'classnames'
import i18n from 'lib/i18n'
import * as c from 'state/constants'
import nesProp from 'nested-property'
import {WillemotEmails} from '../environments.coffee'
import underscore from 'underscore'

const _ = i18n('dswizard')

let selectInFocusWithin = false
/**
 * Customization object for the react-select using the same style like other components on tha site.
 */
export const customCreatableSelectStyles = {
    control: (base, state) => {
        selectInFocusWithin = state.isFocused
        return {
        ...base,
        flex: "4",
        fontSize: "12px",
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "flex-end",
        color: "#000",
        backgroundColor: state.isDisabled ? "#f9f9f9" : "#fff",
        borderColor: "#d9d9d9 #ccc #b3b3b3",
        borderRadius: "2px",
        border: "1px solid #d9d9d9",
        minHeight: "25px",
        maxHeight: "auto",
        //height: state.isFocused ? "auto" : "25px",
        boxShadow: state.isFocused ? null : null,
        "&:hover": {
        borderColor: "#d9d9d9 #ccc #b3b3b3"
        },
        "&:focus": {
        borderColor: "#d9d9d9 #ccc #b3b3b3"
        },
        padding: 0,
        margin: 0,
        overflow: state.isFocused ? null : "hidden"
    }},
    menu: base => ({
        ...base,
        borderRadius: 2,
        hyphens: "auto",
        marginTop: 0,
        textAlign: "left",
        wordWrap: "break-word"
    }),
    menuList: base => ({
        ...base,
        padding: 0,
        verticalAlign: "baseline"
    }),
    singleValue: (base, state) => ({
        ...base,
        minHeight: "16px",
        lineHeight: "14px",
        color: "black",
    }),
    multiValue: (base, state) => ({
        ...base,
        minHeight: "16px",
        lineHeight: "14px",
        maxHeight: "18px",
        border: "0.5px solid #003366",
        background: '#003366',
        color: "black",
        div: {
            color: "black",
            fontSize: '1.2em',
            lineHeight: '0.8em'
        }
    }),
    /* noOptionsMessage: (base, state) => ({
        ...base,
        padding: 0,
        height: "20px",
        lineHeight: "16px"
    }), */
    option: (base, state) => ({
        ...base,
        padding: 0,
        fontSize: '1em',
        maxHeight: "25px"
    }),
    valueContainer: (base, state) => ({
        ...base,
        padding: 0,
        margin: 0,
        top: 0
    }),
    multiValueRemove: (base, state) => ({
        ...base,
        display: state.isDisabled ? "none" : null,
        padding: 0
    }),
    clearIndicator: (base, state) => ({
        ...base,
        padding: 0
    }),
    dropdownIndicator: (base, state) => ({
        ...base,
        marginTop: 0,
        padding: 0
    }),
    indicatorsContainer: (base, state) => ({
        ...base,
        padding: 0,
        margin: 0,
        height: "23px",
        top: 0
    }),
    indicatorSeparator: (base, state) => ({
        ...base,
        padding: 0,
        margin: 0,
        height: "0",
        top: 0
    }),
    group: (base, state) => ({
        ...base,
        padding: 0,
        margin: 0,
        height: "20px",
        top: 0
    }),
    groupHeading: (base, state) => ({
        ...base,
        padding: 0,
        margin: 0,
        height: "20px",
        top: 0
    }),
    input: (base, state) => ({
        ...base,
        padding: 0,
        margin: "2px 0 0 0",
        height: "20px",
        top: 0,
        fontSize: '1.2em',
        lineHeight: '0.8em',
        width: selectInFocusWithin ? '100%!important' : 'auto',
        div: {
            width: selectInFocusWithin ? '100%!important' : 'auto',
            input: {
                width: selectInFocusWithin ? '100%!important' : 'auto',
            },
        }
    }),
    noOptionsMessage: (base, state) => ({
        ...base,
        padding: 0,
        margin: 0,
        height: "20px",
        fontSize: '1em'
    }),
    placeholder: (base, state) => ({
        ...base,
        fontSize: '1.1em',
        lineHeight: '1.1em'
    })
}

/**
 * Custom dropdown indicator for react-select to be the similar style lik other elements on the page
 * @param {object} props
 */
export const DropdownIndicator = (props) => {
    return reactSelectComponents.DropdownIndicator && (
    <reactSelectComponents.DropdownIndicator {...props}>
        <span className={styles.downArrowHolder}>
                <span className={styles.downArrow}></span>
        </span>
    </reactSelectComponents.DropdownIndicator>
    )
}

/**
 * Custom dropdown indicator for react-select to be the similar style lik other elements on the page
 * @param {object} props
 */
export const NoOptionsMessage = (props) => {
    return reactSelectComponents.DropdownIndicator && (
    <reactSelectComponents.NoOptionsMessage {...props}>
        {props.selectProps.noOptionsLabel || _('noOptions')}
    </reactSelectComponents.NoOptionsMessage>
    )
}

const getDeleteIcon = () => {
    try {
        return require(`resources/images/a-trash_1x_ovbBlue.svg`)
    } catch(err) {
        return require(`resources/images/icn-no-result.svg`)
    }
}

/**
 *
 * @param {*} props
 */
const SelectRemovableOption = props => {
    return (
        <div className={styles.creatableOptionContainer}>
        <reactSelectComponents.Option {...props} className={styles.creatableOptionItem}/>
            {props.data.isRecent ?
                <span>
                    <button type="button" className={styles.creatableOptionItem} onClick={event => {
                        event.preventDefault()
                        props.delete(props.value)
                    }}>
                        <img src={getDeleteIcon()}/>
                    </button>
                </span>
                : null
            }
        </div>
    )
}

/**
 * This is a custom MultiValueRemove for react select to be able set a separate unremovable value in dropdown
 * but the rest is still dynamic
 * @param {object} props
 */
const MultiValueRemove = props => {
    return (
        <reactSelectComponents.MultiValueRemove {...props}>
            {!props.data.isPermanentSelected ? props.children : null}
            {!props.data.isPermanentSelected ? props.children : null}
        </reactSelectComponents.MultiValueRemove>
    )
}

const MultiValueContainer = props => {
    return (
        <span className={styles.elementsInRow}>
            {props.data.firstCC ?
                <span className={styles.elementsInRow}>
                    <span className={styles.ccSpan}>CC: </span> <reactSelectComponents.MultiValueContainer {...props} />
                </span>
                :
                <reactSelectComponents.MultiValueContainer {...props} />
            }
        </span>
    )
}

const ValueContainer = ({ children, ...props }) => {

    // sort the recipients and mark the first CC to render a separator between recipients
    /* if (children && children[0] && children[0].length) {
        children[0].sort((a,b) => {
            return a.props.data.isCC > b.props.data.isCC ? 1 : -1
        })
        let firstCCIndex = -1
        children[0].forEach((item, index)=>{
            firstCCIndex === -1 && item.props.data.isCC ? (firstCCIndex = index) : null
        })
        if (firstCCIndex !== -1) {
            children[0][firstCCIndex].props.data.firstCC = true
        }
    } */
    return (<reactSelectComponents.ValueContainer {...props} className={styles.selectValueContainer}>
        <div className={styles.composeRecipients}>
            {children}
        </div>
        <div className={styles.ccButtonHolder}>
            {props.selectProps.showExtraButton ?
            <div className={styles.ccButtonInSelect} onClick={(e)=>{
                e.preventDefault()
                e.stopPropagation()
                props.selectProps.onClickExtraButton(e)
            }}>
                CC
            </div>
            : null}
        </div>
    </reactSelectComponents.ValueContainer>)
}

/**
 * To validate the inserting value you can use this property for CreatableSelect
 * "isValidNewOption={(value)=>{
 *      return isAnEmail(value.trim())
 * }}"
 *
 */
export default class CustomSelect extends React.Component {
    static propTypes = {
        formatCreateLabel: React.PropTypes.string,
        customClassName: React.PropTypes.string,
        handleOnBlur: React.PropTypes.func,
        setDeleteItemByOption: React.PropTypes.func,
        showExtraButton: React.PropTypes.bool,
        isCreatableSelect: React.PropTypes.bool,
        onClickExtraButton: React.PropTypes.func,
    }

    static defaultProps = {
        isCreatableSelect: true
    }

    constructor(props) {
        super(props)
    }

    /**
     * Must handle on blur because else loose values. ()
     * @param {*} event
     */
    handleOnBlur(event){
        const {/* value, */ onChange} = this.props
        /*let newValue = []

        if (value && value.value) {
            newValue = newValue.concat( value.value )
        }

        if (event && event.target && event.target.value) {
            newValue.push({label: event.target.value, value: event.target.value})
        } */

        // add values to the list when blur, otherwise that will be lost
        onChange({label: event.target.value, value: event.target.value})

        return newValue
    }

    /**
     * Render creatable select
     */
    renderCreatable() {
        const {
            formatCreateLabel, handleOnBlur,
            customClassName, showExtraButton, onClickExtraButton, setDeleteItemByOption, noOptionsLabel } = this.props
        return (
            <CreatableSelect
                {...this.props}
                onBlur={
                    (e) => {
                        if (handleOnBlur) {
                            handleOnBlur(e)
                        } else {
                            this.handleOnBlur(e)
                        }
                    }
                }
                noOptionsLabel={noOptionsLabel}
                openMenuOnFocus={true}
                placeholder={''}
                onBlurResetsInput={false}
                isSearchable
                styles={customCreatableSelectStyles}
                formatCreateLabel={(value) => `${formatCreateLabel} ${value}`}
                components={{
                    DropdownIndicator, NoOptionsMessage, Option: (p) => (SelectRemovableOption({ ...p, delete: setDeleteItemByOption })),
                    MultiValueRemove,/* MultiValueContainer,*/ ValueContainer
                }}
                className={customClassName}
                showExtraButton={showExtraButton && !isDisabled}
                onClickExtraButton={onClickExtraButton}
            />)
    }

    /**
     * Render regular select
     */
    renderSelect() {
        const {handleOnBlur, customClassName, showExtraButton, onClickExtraButton, setDeleteItemByOption, noOptionsLabel} = this.props
        // placeholder={_('searchPromptText')}
        return (
        <ReactSelect2
            {...this.props}
            value={this.props.value || ""}
            onBlur={
                (e)=> {
                    if (handleOnBlur) {
                        handleOnBlur(e)
                    } else {
                        this.handleOnBlur(e)
                    }
                }
            }
            noOptionsLabel={noOptionsLabel}
            openMenuOnFocus={true}
            placeholder={''}
            onBlurResetsInput={false}
            isSearchable
            styles={customCreatableSelectStyles}
            components={{ DropdownIndicator, NoOptionsMessage, Option: (p) => (SelectRemovableOption({...p, delete: setDeleteItemByOption})),
                MultiValueRemove,/* MultiValueContainer,*/ ValueContainer }}
            className={customClassName}
            showExtraButton={showExtraButton && !isDisabled}
            onClickExtraButton={onClickExtraButton}
        />)
    }

    render() {
        const {isCreatableSelect} = this.props
        return isCreatableSelect ? this.renderCreatable() : this.renderSelect()
    }
}

//--------------------------------------------------------------------------------------------
// Section of random stuffs/tools for DSWizard what are used for processing/resolving few simple tings
// and take place in the code.
//--------------------------------------------------------------------------------------------

/**
* Determine if the form is valid for tarification module.
* @param {*} moduleKey
* @param {*} packageDSDocuments
* @returns Bool - true if the requirements are satisfied
*/
export const isATarificationAndHasAMarkedTemplate = (moduleKey, packageDSDocuments, subModuleKey) => {
    // check if we are on tarification module to check the specific rules for this module
    let isRequiredTarification = (moduleKey === c.DS_MODULE_CLIENT_TARIFICATION && subModuleKey !== c.DS_MODULE_CLIENT_TARIFICATION)

    // check if there is set one of the marked document templates to be able to validate the form.
    let hasSetOneObligatedTemplate = false
    if (packageDSDocuments) {
        packageDSDocuments.forEach((oneDocument) => {
            hasSetOneObligatedTemplate = hasSetOneObligatedTemplate ||
                nesProp.get(oneDocument, "documentTemplate.requiredOnOffers")
        })
    }

    return isRequiredTarification && hasSetOneObligatedTemplate
}

/**
* Determine if the form is valid for mandate (prem) module.
* @param {*} moduleKey
* @param {*} packageDSDocuments
* @returns Bool - true if the requirements are satisfied
*/
export const isMandateAndHasAMarkedTemplate = (moduleKey, packageDSDocuments, subModuleKey) => {
    // check if we are on mandate module to check the specific rules for this module
    let isRequiredMandate = moduleKey === c.DS_MODULE_CLIENT_CONTRACT_PREM

    // check if there is set one of the marked document templates to be able to validate the form.
    let hasSetOneObligatedTemplate = false
    if (packageDSDocuments) {
        packageDSDocuments.forEach((oneDocument) => {
            hasSetOneObligatedTemplate = hasSetOneObligatedTemplate ||
                nesProp.get(oneDocument, "documentTemplate.requiredOnPrem")
        })
    }

    return isRequiredMandate && hasSetOneObligatedTemplate
}
/**
 * Get the moduleKey from package if loaded
 */
export const getModuleKeyOfPackage = (packageDSDocuments) => {
    let packageInstance = {}
    if (packageDSDocuments) {
        packageInstance = nesProp.get(packageDSDocuments, "0.package")
    }

    return nesProp.get(packageInstance, "uploadedOnModule")
}

/**
 * Get the suModuleKey from package if loaded
 */
export const getSubModuleKeyOfPackage = (packageDSDocuments) => {
    let packageInstance = {}
    if (packageDSDocuments) {
        packageInstance = nesProp.get(packageDSDocuments, "0.package")
    }

    return nesProp.get(packageInstance, "subModuleKey")
}

/**
 * This function provide a list for select of intervals durations
 */
export const getRemainderIntervalOptionList = (security) => {
    let remainderIntervalOptions = nesProp.get(security, "DigitalSignatureHardLists.DigitalSignatureRemainderIntervals")
    //nesProp.get(security, "DigitalSignatureHardLists.DigitalSignatureRemainderIntervalRepeat")

    if (remainderIntervalOptions) {
        remainderIntervalOptions = remainderIntervalOptions.map((item) => {
            return {
                ...item,
                label: _('remainderIntervalOptions_'+item.value)
            }
        })
    }

    return remainderIntervalOptions
}

/**
 * This function provide a list for select of intervals repeats
 */
export const getRemainderRepeatsOptionList = (security) => {
    let remainderRepeatsOptions = nesProp.get(security, "DigitalSignatureHardLists.DigitalSignatureRemainderIntervalRepeat")

    if (remainderRepeatsOptions) {
        remainderRepeatsOptions = remainderRepeatsOptions.map((item) => {
            return {
                ...item,
                label: _('remainderRepeatsOptions_'+item.value)
            }
        })
    }

    return remainderRepeatsOptions
}

/**
* This function provide a list for select of document types
*/
export const getDocumentTemplateOptionList = (templates, lang, moduleKey, subModuleKey, returnOnlyRequiredOnPrem = false, doctypeFromClaimWizard = '') => {
    let result = []

    // no templates found
    if (!templates || templates.length == 0) {
        console.warn("Trying to process template list, but no template loaded yet.")
        return result
    }

    // check if there is prem case or if wizard is from office module or claim wizard where the documents are strict restricted and preselected
    let isPrem = moduleKey === c.DS_MODULE_CLIENT_CONTRACT_PREM
    const isOffice = moduleKey === c.DS_MODULE_OFFICE
    const isClaimWizard = moduleKey === c.DS_MODULE_CLAIM_WIZARD
    const isClaimsModule = moduleKey === c.DS_MODULE_CLIENT_CLAIMS

    // filter the available templates for the current module
    result = templates.filter((item) => {
        let isEnabled = false
        let noModuleRestriction = (!item.availableOnModule || item.availableOnModule.length == 0)

        // no restriction, means is available
        if (noModuleRestriction && !isPrem && !isOffice && !isClaimWizard && !isClaimsModule) {
            isEnabled = true
        }

        // check the current module in the template whitelist
        if (!noModuleRestriction) {
            let matches = item.availableOnModule.filter((oneModuleFlag) => {
                let shouldKeep = false

                // normal case, keep the templates enabled on the template
                if (oneModuleFlag.module == moduleKey) {
                    shouldKeep = true
                }

                // BEWB-880 there should be available only documents that have available on tarification module and if is detail page just remove the ones that are required for offers
                if (moduleKey == c.DS_MODULE_CLIENT_TARIFICATION && subModuleKey == c.DS_MODULE_CLIENT_TARIFICATION && item.requiredOnOffers) {
                    shouldKeep = false
                }

                
                //handle new prem functionality when requiredOnPrem should not be visible in regular options list but has to be selected by default
                if (isPrem && ((!item.requiredOnPrem && returnOnlyRequiredOnPrem) || (item.requiredOnPrem && !returnOnlyRequiredOnPrem))) {
                    shouldKeep = false

                } else if (isPrem && item.requiredOnPrem && returnOnlyRequiredOnPrem) {
                    shouldKeep = true
                }
                
                // when is claimWizardModule, document template available shout match lowValue to document type from claimWizard 
                if (isClaimWizard && oneModuleFlag.module === moduleKey && item.indexType.lowValue && item.indexType.lowValue  === doctypeFromClaimWizard) {
                    shouldKeep = true
    
                } else if (isClaimWizard && oneModuleFlag.module === moduleKey && item.indexType.lowValue && item.indexType.lowValue  !== doctypeFromClaimWizard) {
                    shouldKeep = false
                }
                return shouldKeep
            })

            if (matches.length > 0) {
                isEnabled = true
            }
        }

        return isEnabled
    })

    // reconstruct hierarchy
    result = result.map((item) => {
        return {
            label: (item && item.title && (item.title[lang] || item.title['nl'] || item.title['fr'] || item.title['en'])) || '!!! no title template',
            value: item._id,
            teamList: item.teamList,
            teamSubgroupList: item.levenSubgroups
        }
    })

    // sort result in Alphabetic order
    result = result.sort((item, item2) => {
        if (item.label < item2.label) { return -1 }
        if (item.label > item2.label) { return 1 }
        if (item.label === item2.label) { return 0 }
    }) || []


    return result
}

/**
 * This function provide a list for select of languages
 */
export const getLanguageOptionList = () => {
    return [
        {value: 'nl', label: _("nl")},
        {value: 'fr', label: _("fr")},
        //{value: 'en', label: _("en")},
    ]
}

/***
 * This function return a the list of teams on the preferred language.
 * The result is in [{value:, label:},...] form to be digestible for Select input.
 *
 * @param {*} clientOptionsDict
 * @param {*} appLanguage
 * @returns
 */
export const getTeamsOptionList = (clientOptionsDict, appLanguage) => {
    const rawWillemotTeams = (clientOptionsDict && clientOptionsDict['TEAM_WILLEMOT']) || {}
    const teams = []

    Object.keys(rawWillemotTeams).forEach(key => {
        teams.push({
            value: key,
            label: rawWillemotTeams[key][appLanguage]
        })
    })

    return teams
}

/***
 * This function return a the list of team subgroups on the preferred language.
 * The result is in [{value:, label:},...] form to be digestible for Select input.
 *
 * @param {*} clientOptionsDict
 * @param {*} appLanguage
 * @returns
 */
export const getTeamSubgroupsOptionList = (subgroupsList, appLanguage) => {
    const subGroups = []

    if (!subgroupsList || subgroupsList.length === 0) {
        return []
    }

    subgroupsList.forEach(oneSubgroup => {
        subGroups.push({
            value: String(oneSubgroup._id),
            label: oneSubgroup[appLanguage] || oneSubgroup['nl']
        })
    })

    return subGroups
}

/**
 * This function will return true in case when all of the packages has tarification number set.
 * Will return with false when one of the documents template require tarification number but not set.
 * @param {*} packageDSDocuments
 */
export const allDocumentsHasTarificationNumber = (packageDSDocuments) => {

    // if no documents then no tarification id needed
    if (!packageDSDocuments || packageDSDocuments.length == 0) {
        return true
    }

    // initialise result value
    let allHasTarificationNumber = true

    // iterate the array for values
    packageDSDocuments.forEach((oneDocument, index) => {
        let oneTemplate = nesProp.get(packageDSDocuments, index+".documentTemplate")
        let subModuleKey = nesProp.get(packageDSDocuments, index+".subModuleKey")
        let isTarificationModuleRequired = (
            nesProp.get(oneTemplate, "uploadedOnModule") == c.DS_MODULE_CLIENT_TARIFICATION &&
            subModuleKey !== c.DS_MODULE_CLIENT_TARIFICATION
        )
        let hasTarificationNumber = nesProp.get(packageDSDocuments, index+".tarificationNumber")

        // in case when a template require a tarification number but there is not tarification linked, we set the result to false
        if (isTarificationModuleRequired && !hasTarificationNumber) {
            allHasTarificationNumber = false
        }
    })

    return allHasTarificationNumber
}

/**
 * This function will return the list of tarificationNumbers used
 * @param {Array} packageDSDocuments
 * @returns Array with objects
 */
export const getDocumentsTarificationNumbersList = (packageDSDocuments) => {

    // if no documents then no tarification id needed
    if (!packageDSDocuments || packageDSDocuments.length == 0) {
        return []
    }

    // initialise result value
    let numbersList = []

    // iterate the array for values
    packageDSDocuments.forEach((oneDocument, index) => {
        let oneTemplate = nesProp.get(packageDSDocuments, index+".documentTemplate")
        let isTarificationModuleRequired = (nesProp.get(oneTemplate, "uploadedOnModule") !== c.DS_MODULE_CLIENT_TARIFICATION)
        let tarificationNumber = nesProp.get(packageDSDocuments, index+".tarificationNumber")
        let tarificationId = nesProp.get(packageDSDocuments, index+".tarificationId")

        // in case when a template require a tarification number but there is not tarification linked, we set the result to false
        if (isTarificationModuleRequired && tarificationNumber) {
            numbersList.push({tarificationId, tarificationNumber})
        }
    })

    return numbersList
}

/**
 * Filter the team list for the current broker using the values got from auth procedure.
 * If no whitelist for the current broker, then no teams can be selected in the form.
 * @param {*} teamsOptions
 * @param {*} whiteList
 * @param {*} brokerNumber
 * @returns
 */
export const filterTeamsForBroker = (teamsOptions, whiteList, brokerNumber) => {
    // parameter check
    if (!teamsOptions || ! whiteList || !brokerNumber) {
        return []
    }

    // select whitelist by broker number
    let currentWhiteList = nesProp.get(whiteList, brokerNumber)

    // no white list the no teams can be selected
    if (!currentWhiteList || currentWhiteList.length == 0) {
        return []
    }

    // filter the list by broker white list
    let filteredTeams = teamsOptions.filter((oneTeamOption) => {
        // determine initial value for the flag what decide if the current option can be used by the broker
        let canKeep = false

        // check if the team can be remain
        currentWhiteList.forEach((oneWhiteTeam) => {
            if (String(oneWhiteTeam) === String(oneTeamOption.value)) {
                canKeep = true
            }
        })

        return canKeep
    })

    return filteredTeams
}

/**
 * Filter the team list for the current broker using the values got from auth procedure.
 * If no whitelist for the current broker, then no teams can be selected in the form.
 * @param {*} documentTemplateOptions
 * @param {*} whiteList
 * @param {*} brokerNumber
 * @param {*} teamIndex
 * @param {*} teamSubgroupId
 * @returns
 */
export const filterTemplatesForBroker = (documentTemplateOptions, whiteList, brokerNumber, teamIndex = false, teamSubgroupId = "") => {
    // parameter check
    if (!documentTemplateOptions || !whiteList || !brokerNumber) {
console.error("filterTemplatesForBroker NO ARGS: ", "documentTemplateOptions: ", documentTemplateOptions)
console.error("filterTemplatesForBroker NO ARGS: ", "whiteList: ", whiteList)
console.error("filterTemplatesForBroker NO ARGS: ", "brokerNumber: ", brokerNumber)
        return []
    }

    // select whitelist by broker number
    let currentWhiteList = nesProp.get(whiteList, brokerNumber)

    // no white list the no teams can be selected
    if (!currentWhiteList || currentWhiteList.length == 0) {
        return []
    }

    // filter the list by broker white list
    let filteredTemplates = documentTemplateOptions.filter((oneTemplateOption) => {
        // determine initial value for the flag what decide if the current option can be used by the broker
        let canKeep = false
        let templateTeamList = nesProp.get(oneTemplateOption, "teamList") || []

        // check if the team can be remain
        currentWhiteList.forEach((oneWhiteTeam) => {
            templateTeamList.forEach((oneTemplateTeam) => {
                // can keep if the whitelists are intersected
                if (String(oneWhiteTeam) === String(oneTemplateTeam.teamIndex)) {
                    // can keep if there is a selected team and that is supported by the template
                    if (!teamIndex || (teamIndex && String(teamIndex) === String(oneTemplateTeam.teamIndex))) {
                        if (teamSubgroupId && oneTemplateOption.teamSubgroupList && oneTemplateOption.teamSubgroupList.length > 0) {
                            oneTemplateOption.teamSubgroupList.forEach((oneSubgroup) => {
                                // if there is a subgroup selected and a template has a list of subgroups, then must be filtered for the group
                                if (String(oneSubgroup.subgroup) === String(teamSubgroupId)) {
                                    canKeep = true
                                }
                            })
                        } else {
                            // if not subgroup specified then the template should keep for listing
                            canKeep = true
                        }
                    }
                }
            })
        })

        return canKeep
    })

    return filteredTemplates
}

/**
 * Returns a whitelist object with arrays containing indexes of teams for the brokers
 * @param {*} brokers - brokers list from Oracle: {brNr: main: teamsWillemot: []}
 * @returns object with arrays, indexed by brokerNumber
 */
export const processBrokerWhiteListFromBrokersList = (brokers) => {
    if (!brokers) {
        return {}
    }

    let brokerNumberList  = Object.keys(brokers)

    if (brokerNumberList.length === 0) {
        return {}
    }

    let result = {}

    brokerNumberList.forEach((brokerNumber) => {
        let oneBroker = brokers[brokerNumber]
        let teamsWilleot = nesProp.get(oneBroker, "main.teamsWillemot")

        result[brokerNumber] = teamsWilleot
    })

    return result
}

/**
 * This function parse a package after documents with template what are sent to connective.
 * If there is documents sent to connective then return true, else return false.
 * @param {*} packageDSDocuments - list of documents from state store
 * @returns Boolean
 */
export const areThereDocumentSentToConnective = (packageDSDocuments, DSDocumentOriginTypes) => {

    // if no documents then no documents sent for connective
    if (!packageDSDocuments || packageDSDocuments.length == 0) {
        return false
    }

    // initialise result value
    let areDocuments = false

    // parse all documents to know if there is a document for signing or not
    packageDSDocuments.forEach((oneDocument) => {
        let oneTemplate = nesProp.get(oneDocument, "documentTemplate")
        let mustBeSignedThisDocument = isDocumentMustBeSigned(DSDocumentOriginTypes, oneDocument.origin, oneTemplate)

        areDocuments = areDocuments || mustBeSignedThisDocument
    })

    return areDocuments
}

//--------------------------------------------------------------------------------------------
// Section where to hold few functions for the DSWizard form.
// Here are the functions what are necessary to exists, but not needed to see all the time to
// understand how it is working generally
//--------------------------------------------------------------------------------------------

/**
 *
 * @param {*} formInputs
 * @param {*} valueList
 * @returns Patched form inputs
 */
export const patchFormInputValuesByValueList = (formInputs, valueList) => {
    if (!formInputs || !valueList) {
        return formInputs
    }

    let inputNameList = Object.keys(formInputs)
    let valueNameList = Object.keys(valueList)

    inputNameList.forEach((oneInputName) => {
        valueNameList.forEach((oneValueName) => {
            if (oneInputName === oneValueName) {
                formInputs[oneInputName].value = valueList[oneValueName]
            }
        })
    })

    return formInputs
}

/**
 * Return true if there are any of fill ins
 * @param {number} packageDSDocuments
 * @returns Boolean - is there is any of the document is filled in the return true
 */
export const checkDocumentAfterFillIns = (packageDSDocuments) => {
    let thereIsAFillIn = false

    if (!packageDSDocuments || packageDSDocuments.length == 0) {
        return thereIsAFillIn
    }

    packageDSDocuments.forEach((item) => {
        if (item.brokerFilledValues && item.brokerFilledValues.length > 0) {
            thereIsAFillIn = true
        }
    })

    return thereIsAFillIn
}

/**
 * This function find a document from an array of docs by Id
 * @param {*} docId
 * @param {*} docList
 * @returns Document instance from the array
 */
export const findDocumentFromListById = (docId, docList) => {
    if (!docList || docList.length == 0 || !docId) {
        return false
    }

    let docListFiltered = docList.filter((item) => {
        return String(item._id) === String(docId)
    })

    if (!docListFiltered || docListFiltered.length == 0) {
        return false
    }

    let theDoc = docListFiltered[0]

    return theDoc
}

/**
 * This function validate the fill ins and placeholder existence for all of the docs in the list
 * @param {array} docList DsDocument instance list
 * @param {number} totalNumberOfSigners stakeholder total count
 * @param {object} DSDocumentOriginTypes Constants for document origin operations
 * @returns Document instances with errors or false when there are no errors
 */
export const getTheListOfInvalidDocuments = (docList, totalNumberOfSigners, DSDocumentOriginTypes) => {
    if (!docList || docList.length == 0) {
        return false
    }

    // result is the list of docs with issues by fields detected from template
    let docListFiltered = docList.filter((item) => {
        return !isValidDocument(item, totalNumberOfSigners, DSDocumentOriginTypes)
    })

    if (!docListFiltered || docListFiltered.length == 0) {
        return false
    }

    return docListFiltered
}

/**
 * This function validate the signers count used.
 * @param {array} docList DsDocument instance list
 * @param {number} stakeholders stakeholder total count
 * @param {object} DSDocumentOriginTypes Constants for document origin operations
 * @param {object} signerAvailabilityOfTemplates availability
 * @returns {stakeholderUsageMap, areNonUsedStakeholders}
 * stakeholderUsageMap object with id value as prop name and boolean value, means is used or not as signer in a ny doc
 * areNonUsedStakeholders boolean value
 */
export const isUsedAllOfStakeholders = (docList, stakeholders, DSDocumentOriginTypes, signerAvailabilityOfTemplates) => {
    let stakeholderUsageMap = {}
    let stakeholdersMap = {}

    for (let j=0; j < stakeholders.length; j++) {
        let oneStake = stakeholders[j]
        stakeholderUsageMap[oneStake._id] = oneStake
    }

    for (let j=0; j < stakeholders.length; j++) {
        let oneStake = stakeholders[j]
        stakeholdersMap[oneStake._id] = oneStake
    }

    if (!docList || docList.length == 0) {
        return stakeholderUsageMap
    }

    // result is the list of docs with issues by fields detected from template
    for (let i=0; i < docList.length; i++) {
        let oneDoc = docList[i]

        // check the uploaded and oracle documents for placed placeholders by stakeholder Id to check the usage
        if (oneDoc.origin !== DSDocumentOriginTypes.DS_ORIGIN_GENERATED) {

            if (oneDoc.signatureManualPlaceholders && oneDoc.signatureManualPlaceholders.length) {
                for (let j=0; j < oneDoc.signatureManualPlaceholders.length; j++) {
                    let holder = oneDoc.signatureManualPlaceholders[j]

                    stakeholderUsageMap[holder.stakeholderId] = false
                } // j var
            }

        } else {
        // check the generated documents for placed placeholders by signature placeholder usage
            let isItExistFirstSignerPlaceholder = false
            let isItExistSecondSignerPlaceholder = false
            let isItExistBrokerSignerPlaceholder = false
            let templateId = oneDoc.documentTemplateId

            // extend the languageWhiteList with the values what support the selected template (check html existence in record)
            if (signerAvailabilityOfTemplates && signerAvailabilityOfTemplates.length > 0 && templateId) {
                // find template in the list of all templates
                let signerAvailabilities = signerAvailabilityOfTemplates.filter((item) => {
                    return (item.templateId === templateId)
                })

                let signerAvailability = nesProp.get(signerAvailabilities, "0")

                // see in the console, if the template have no signer configured in the template content.
                if (!signerAvailability) {
                    console.warn("No signer types available for the template to validate stakeholder usage: ", templateId && templateId._id, "signer types:", signerAvailability)
                }

                if (signerAvailability && signerAvailability.signerTypes) {
                    isItExistFirstSignerPlaceholder = isItExistFirstSignerPlaceholder || signerAvailability.signerTypes[oneDoc.language].includes("CLIENT")
                    isItExistSecondSignerPlaceholder = isItExistSecondSignerPlaceholder || signerAvailability.signerTypes[oneDoc.language].includes("OTHER_PERSON")
                    isItExistBrokerSignerPlaceholder = isItExistBrokerSignerPlaceholder || signerAvailability.signerTypes[oneDoc.language].includes("BROKER")
                }
            }

            // iterate existing stakeholders, if they are supported by the template to be able to mark the usage of it.
            // if finally there is some stakeholder who are not listed anywhere stays undefined in the stakeholderUsageMap object
            for (let j=0; j < stakeholders.length; j++) {
                let oneStake = stakeholders[j]

                if (oneStake.signerType === "CLIENT" && isItExistFirstSignerPlaceholder) {
                    stakeholderUsageMap[oneStake._id] = false
                }
                if (oneStake.signerType === "OTHER_PERSON" && isItExistSecondSignerPlaceholder) {
                    stakeholderUsageMap[oneStake._id] = false
                }
                if (oneStake.signerType === "BROKER" && isItExistBrokerSignerPlaceholder) {
                    stakeholderUsageMap[oneStake._id] = false
                }
            } // j var

        }
    } // main for with i var

    let idArray = Object.keys(stakeholderUsageMap)

    let areNonUsedStakeholders = false

    for (let j=0; j < idArray.length; j++) {
        if (stakeholderUsageMap[idArray[j]]) {
            areNonUsedStakeholders = true
        }
    }

    return {stakeholderUsageMap, areNonUsedStakeholders}
}

/**
 * @param {array} docList DsDocument instance list
 * @param {object} DSDocumentOriginTypes Constants for document origin operations
 */
export const areThereSignableDocuments = (docList, DSDocumentOriginTypes) => {
    let mustSigned = false;

    // result is the list of docs with issues by fields detected from template
    for (let i=0; i < docList.length; i++) {
        let oneDoc = docList[i]

        // check the uploaded and oracle documents for placed placeholders by stakeholder Id to check the usage
        if (oneDoc.origin !== DSDocumentOriginTypes.DS_ORIGIN_GENERATED) {
            mustSigned = mustSigned && true
            break
        } else {
            // let templateId = oneDoc.templateId
            // // extend the languageWhiteList with the values what support the selected template (check html existence in record)
            // if (templates && templates.length && templateId) {
            //     // find template in the list of all templates
            //     let templateForTheNewDoc = templates.filter((item) => {
            //         return (item._id === templateId)
            //     })

            //     // get the template instance from result
            //     let templateInstance = nesProp.get(templateForTheNewDoc, "0")
            // }

            mustSigned = mustSigned && oneDoc.documentTemplate.mustBeSigned
        }
    }

    return mustSigned
}

/**
 * This function do a general check for a document if it is valid. The origin of document is taken in consideration.
 * Error message is set on error
 * @param {*} document
 * @param {*} totalNumberOfSigners
 * @param {*} DSDocumentOriginTypes
 * @returns
 */
export const isValidDocument = (document, totalNumberOfSigners, DSDocumentOriginTypes) => {
    let isValid = false
    switch (document.origin) {
        case DSDocumentOriginTypes.DS_ORIGIN_LOCAL_UPLOAD: {
            isValid = isPlacedSignaturePlaceholder(document, totalNumberOfSigners)
            if(document.isAttachment) {
                isValid = true
            }
            break
        }
        case DSDocumentOriginTypes.DS_ORIGIN_ORACLE: {
            isValid = isPlacedSignaturePlaceholder(document, totalNumberOfSigners)
            break
        }

        case DSDocumentOriginTypes.DS_ORIGIN_GENERATED:
        default: {
            isValid = isValidTheTemplateFill(document)

            // common properties to provide error about a document.
            // For e.g.: the external validation result, or missing signature placeholder
            if (document && document.errorMessages && document.errorMessages.length > 0) {
                // in case when we have any message about the fields, then the document is invalid
                isValid = false
            }
        }
    }



    return isValid
}

/**
 * This function checks a document if filled valid. Checking if the required field are valid and if touched the file.
 * @param {*} dsDocument
 * @returns
 */
export const isValidTheTemplateFill = (dsDocument) => {
    let isValidTheDoc = true

    if (dsDocument && dsDocument.brokerFilledValues) {
        dsDocument.brokerFilledValues.forEach((onField) =>{
            if (onField && onField.required && !onField.value) {
                isValidTheDoc = false
            }
        })
    } else {
        isValidTheDoc = false
    }

    return isValidTheDoc
}

/**
 * Check if signature placeholders are set for document, and all of the signers are added well. No duplicated signers found.
 * @param {object} document
 * @param {number} totalNumberOfSigners
 * @returns boolean
 */
const isPlacedSignaturePlaceholder = (document, totalNumberOfSigners) => {
    let isValid = false
    // check if there is any placeholder, and all of the signers are added to the document
    // <amount> === (totalNumberOfSigners*1)
    if (document && document.signatureManualPlaceholders && document.signatureManualPlaceholders.length > 0 ) {

        let stakeholderIdList = document.signatureManualPlaceholders
        .map((onPHolder) => {
            return onPHolder.stakeholderId
        })
        .filter((item) => !!item)

        // check if no duplicated elements, all are unique stakeholders
        // rule is: minimum one stakeholder must added (meeting on 22.03.2023)
        // this rule is no more needed but the snippet is "&& (stakeholderIdList.length === new Set(stakeholderIdList).size)"
        if (stakeholderIdList && stakeholderIdList.length > 0 ) {
            isValid = true
        }
    }

    return isValid;
}

/**
 * Filter documents if documents ar loaded.
 * @param {*} documents
 * @param {*} packageId
 * @returns
*/
export const filterDocumentsByPackageId = (documents, packageId) => {
    let packageDSDocuments = documents && documents.filter((item)=>(nesProp.get(item, "packageId") === packageId)) || []
    return packageDSDocuments
}

/**
 * This function will check a given documents list for documents that require signing
 * @param {*} packageDSDocuments
 * @param {*} DSDocumentOriginTypes the origin types struct
 * @returns boolean
 */
export const requireSigning = (packageDSDocuments, DSDocumentOriginTypes) => {
    const docRequireSign = packageDSDocuments.find(oneDoc => {

        let isNeededToSign = false
        switch (oneDoc.origin) {
            case DSDocumentOriginTypes.DS_ORIGIN_LOCAL_UPLOAD:
            case DSDocumentOriginTypes.DS_ORIGIN_ORACLE:{
                isNeededToSign = true
                break
            }

            case DSDocumentOriginTypes.DS_ORIGIN_GENERATED:
            default: {
                isNeededToSign = oneDoc.documentTemplate && oneDoc.documentTemplate.mustBeSigned
            }
        }

        return isNeededToSign
    })

    return docRequireSign ? true : false
}

/**
 *
 * @param {*} packageDSDocuments
 * @param {*} DSDocumentOriginTypes
 * @returns
 */
export const requireSmsOtpSigning = (packageDSDocuments, DSDocumentOriginTypes) => {
    const sigType = packageDSDocuments.find( oneDoc => {

        let isNeededSmsOtp = false
        switch (oneDoc.origin) {
            case DSDocumentOriginTypes.DS_ORIGIN_LOCAL_UPLOAD:
            case DSDocumentOriginTypes.DS_ORIGIN_ORACLE:{
                isNeededSmsOtp = true
                break
            }

            case DSDocumentOriginTypes.DS_ORIGIN_GENERATED:
            default: {
                isNeededSmsOtp = oneDoc.documentTemplate && oneDoc.documentTemplate.digitalSignatureType == 'SmsOtp'
            }
        }

        return isNeededSmsOtp

    })
    return sigType ? true : false
}

/**
 * Check selected email address to saved vilemot addresses
 * @param {*} email
 * @returns
 */
export const isWillemotEmail = (email) => {
    if (WillemotEmails) {
        for (const willMail of WillemotEmails) {
            if (email.includes(willMail)) {
                return true
            }
        }
    }

    return false
}


/**
 * Get all of the client contract numbers in a list what is digestible for react select.
 */
export const getContractNumbersInOptionList = (client) => {
    let result = []
    let contracts = nesProp.get(client, "contracts")

    if (!contracts || contracts.length === 0) {
        return result
    }

    let objKeys = Object.keys(contracts)
    result = objKeys && objKeys.map((oneKey) => {
        let contractNumber = nesProp.get(contracts, oneKey + ".contractMain.contractNumber")
        let contractId = nesProp.get(contracts, oneKey + ".contractMain.contractId")
        return {label: contractNumber, value: contractNumber, contractId: contractId}
    })

    return result
}

/**
 * This function select an id from parameters by
 * @param {*} moduleType
 */
export const getEntityIdByModule = (moduleType, clientId, contractId, claimId, tarificationId) => {
    switch(moduleType) {
        case "client": {
            return clientId
        }
        case "contract": {
            return contractId
        }
        case "tarification": {
            return tarificationId
        }
        case "claim": {
            return claimId
        }
    }
}

/**
 * This function select an id from parameters by
 * @param {*} moduleKey is a constant what is used to initialise the DSWizard, the value is
 * determined by the given properties of the parent module. All of the possible values are stored as constants.
 * This function translate the moduleKey value for the uploader module to be initialised correctly.
 * Cant be used the same constants because the cases differs, don't cover each other, but can be reduced, this is
 * what does this function exactly.
 *
 * @return {String} - argument for moduleType of uploader component.
 */
export const getModuleTypeByModuleKey = (moduleKey) => {
    switch(moduleKey) {
        case c.DS_MODULE_CLIENT_PROFILE: {
            return "client"
        }
        case c.DS_MODULE_CLIENT_CONTRACT: {
            return "contract"
        }
        case c.DS_MODULE_CLIENT_CONTRACT_PREM: {
            return "contract"
        }
        case c.DS_MODULE_CLIENT_CLAIMS: {
            return "claim"
        }
        case c.DS_MODULE_CLIENT_TARIFICATION: {
            return "tarification"
        }
        case c.DS_MODULE_CLAIM_WIZARD: {
            return "claim"
        }
    }
}

/**
 * This function select an id from parameters by
 * @param {*} moduleKey is a constant what is used to initialise the DSWizard and will
 * associate with a module key for Emailer system
 * The module assigning keywords are not the same because, the components have a different amount and kind of sens
 * of modules, and was implemented in different age of the project.
 * @return {String} - argument for moduleType of uploader component.
 */
export const getEmailerModuleKeyByWizardModuleKey = (moduleKey) => {

    switch(moduleKey) {
        case c.DS_MODULE_CLIENT_PROFILE: {
            return "clientsProfile"
        }
        case c.DS_MODULE_CLIENT_CONTRACT: {
            return "clientsDetailsContract"
        }
        case c.DS_MODULE_CLIENT_CONTRACT_PREM: {
            return "clientsDetailsContract"
        }
        case c.DS_MODULE_CLIENT_CLAIMS: {
            return "clientsClaimsDetail"
        }
        case c.DS_MODULE_CLIENT_TARIFICATION: {
            return "clientTarificationDetails"
        }
        case c.DS_MODULE_CLAIM_WIZARD: {
            return "clientsClaimsDetail"
        }
        case c.DS_MODULE_OFFICE: {
            return 'mifid'
        } 
    }
}

/**
 * This function determine if a document must be signed.
 * @param {object} DSDocumentOriginTypes
 * @param {string} origin
 * @param {object} documentTemplate
 * @returns
 */
export const isDocumentMustBeSigned = (DSDocumentOriginTypes, origin, documentTemplate=null) => {
    switch (origin) {
        case DSDocumentOriginTypes.DS_ORIGIN_LOCAL_UPLOAD: {
            return true
            break
        }
        case DSDocumentOriginTypes.DS_ORIGIN_ORACLE:  {
            return true
            break
        }
        case DSDocumentOriginTypes.DS_ORIGIN_GENERATED:
        default: {
            return !!(documentTemplate && documentTemplate.mustBeSigned)
        }
    }
}

/**
 * This function provide the number of the documents in package what require signing and have template.
 * @param {*} packageDSDocuments the list of the documents in the package
 * @param {*} DSDocumentOriginTypes the list of the origin types
 * @returns <Number> from 0 to the number of the documents found by criteria
 */
export const getCountOfGeneratedDocumentsWhatRequireSigning = (packageDSDocuments, DSDocumentOriginTypes) => {
    // initialise result value
    let count = 0

    // if no documents then no documents sent for connective
    if (!packageDSDocuments || packageDSDocuments.length == 0) {
        return count
    }

    // parse all documents to know if there is a document for signing or not
    packageDSDocuments.forEach((oneDocument) => {
        let oneTemplate = nesProp.get(oneDocument, "documentTemplate")
        let mustBeSignedThisDocument = isDocumentMustBeSigned(DSDocumentOriginTypes, oneDocument.origin, oneTemplate)

        if (oneTemplate && oneDocument.origin === DSDocumentOriginTypes.DS_ORIGIN_GENERATED && mustBeSignedThisDocument) {
            count += 1
        }

    })

    return count
}

/**
* When opening the dsWizard from package details we need to reconstruct the selelected listh for oracle documents
* @param {*} packageDocuments
*/
export const setOracleSelectedDocuments = (packageDocuments) => {
    const selectedClaimRelatedOraDocuments = []
    const selectedContractRelatedOraDocuments = []
    const selectedTarificationRelatedOraDocuments = []
    const selectedClientRelatedOraDocuments = []
    const selectedTicketRelatedOraDocuments = []

    for (const oneDoc of packageDocuments) {
        const documentObject = {
            oracleDocumentId: oneDoc.oracleDocumentId,
            id: oneDoc.oracleDocumentId,
            oracleDocumentType: oneDoc.oracleDocumentType || 'D',
            documentSelectionTab: oneDoc.documentSelectionTab
        }

        switch (oneDoc.documentSelectionTab) {
            case 'CLAIM_DOCUMENTS_TAB':
                selectedClaimRelatedOraDocuments.push(documentObject)
                break;
            case 'CONTRACT_DOCUMENTS_TAB':
                selectedContractRelatedOraDocuments.push(documentObject)
                break;
            case 'TARIFICATION_DOCUMENTS_TAB':
                selectedTarificationRelatedOraDocuments.push(documentObject)
                break;
            case 'PROFILE_DOCUMENTS_TAB':
                selectedClientRelatedOraDocuments.push(documentObject)
                break;
            case 'TICKET_DOCUMENTS_TAB':
                selectedTicketRelatedOraDocuments.push(documentObject)
                break;
        }
    }

    return {
        selectedClaimRelatedOraDocuments,
        selectedContractRelatedOraDocuments,
        selectedTarificationRelatedOraDocuments,
        selectedClientRelatedOraDocuments,
        selectedTicketRelatedOraDocuments
    }
}


/**
* This function will transform the uploader provided document result to a structure for selected oracle documents for signing
* @param {array} selectedUploaderDocs
* @param {string} documentSelectionTab
*/
export const prepareOracleDocumentsFromUploaderSelectionDocList = (selectedUploaderDocs, documentSelectionTab, claimWizardDocType) => {
    let resultAtt = []

    if (!underscore.isEmpty(selectedUploaderDocs)) {
        selectedUploaderDocs.forEach((doc) => {
            resultAtt.push({
                oracleDocumentId: doc.ticketDocumentId || doc.id || doc.oracleDocumentId,
                id: doc.ticketDocumentId || doc.id || doc.oracleDocumentId,
                oracleDocumentName: doc.name || doc.ticketDocumentId || doc.oracleDocumentId,
                //if dsWizard has a claimWizardDocType then use it, else use the ticketDocumentType, else use the oracleDocumentType
                oracleDocumentType: claimWizardDocType || doc.ticketDocumentType || doc.oracleDocumentType || 'D',
                documentSelectionTab,
                oracleDocumentUploadDate: doc.date || ''
            })
        })
    }

    return resultAtt
}

/**
 *
 * @param {*} templateId
 * @param {*} templates
 * @param {*} languageOptions
 */
export const getLanguageOptionsByTemplateId = (templateId, templates, languageOptions) => {
    // language can be selected depending on template
    let languagesList = ['nl', 'fr']
    let languageWhiteList = []

    // extend the languageWhiteList with the values what support the selected template (check html existence in record)
    if (templates && templates.length && templateId) {
        // find template in the list of all templates
        let templateForTheNewDoc = templates.filter((item) => {
            return (item._id === templateId)
        })

        // get the template instance from result
        let templateInstance = nesProp.get(templateForTheNewDoc, "0")
        // check the languages if exist in template, what mean check the html path have value on that language index
        languagesList.forEach((oneLang) => {
            let langIndex = ((oneLang === 'nl') ? 0 : (oneLang === 'fr' ? 1 : 2))

            if (nesProp.get(templateInstance, "templateContent.htmlPath." + langIndex)) {
                languageWhiteList.push(oneLang)
            }
        })
    }

    // compose the language list for the current Select element in the render, using th whitelist created using the template.
    let filteredLanguageOptions = languageOptions.filter((item)=>{
        return languageWhiteList.includes(item.value)
    })

    return filteredLanguageOptions
}

/**
* Check if documents are already added to package
* @param {*} oraDocument
* @param {*} packageDSDocuments
* @returns
*/
export const oraDocumentAlreadyInList = (oraDocument, packageDSDocuments) => {
   return packageDSDocuments.some(onePackageDoc => onePackageDoc.oracleDocumentId === oraDocument.id)
}


/**
 *
 * @param {*} oracleIdToRemove
 * @param {*} selectedOraDocuments
 */
export const removeSelectedDocumentFromOraDocuments = (oracleIdToRemove, selectedOraDocuments) => {
    if (!oracleIdToRemove || !selectedOraDocuments) {
        return selectedOraDocuments
    }

    // filter out document by oracle id got bo cursor id
    return selectedOraDocuments.filter(oneDoc => oneDoc.oracleDocumentId !== oracleIdToRemove)
}

/**
 *
 * @param {*} cursor
 * @param {*} packageDSDocuments
 */
export const getOracleIdByCursorFromPackageDSDocuments = (cursor, packageDSDocuments) => {
    let oracleId

    // filter the document by cursor
    packageDSDocuments.forEach((oneDocument) => {
        //extract the oracle Id document to remove from other lists
        if (oneDocument.cursor === cursor && oneDocument.oracleDocumentId) {
            oracleId = oneDocument.oracleDocumentId
        }
    })

    return oracleId
}

/**
 * This function remove a dsdocument from the list of documents in the package and put the list
 * back in the state.
 * @param {*} cursor
 * @param {*} packageDSDocuments
 */
export const removeDSDocumentFromThePackage = (cursor, packageDSDocuments) => {
    // filter the document by cursor
    return packageDSDocuments.filter((oneDocument) => {
        return (oneDocument.cursor !== cursor)
    })
}


// export const fetchFileSizesForDsDocuments = async () => {

// }

export const getSignerAdderButtonsFlags = (packageDSDocuments, DSDocumentOriginTypes, isPrem, signerAvailabilityOfTemplates) => {
    const listOfGeneratedDocuments = packageDSDocuments && packageDSDocuments.filter(item => item.origin === DSDocumentOriginTypes.DS_ORIGIN_GENERATED)
    const thereAreOtherDocumentsThanGenerated = (listOfGeneratedDocuments.length !== packageDSDocuments.length)

    // init existence of signers placeholders
    // in case of existence a PDF document, what is not generated, then must let to use all fo the signer types
    let isItExistFirstSignerPlaceholder = thereAreOtherDocumentsThanGenerated ? true : false
    let isItExistSecondSignerPlaceholder = thereAreOtherDocumentsThanGenerated ? true : false
    let isItExistBrokerSignerPlaceholder = thereAreOtherDocumentsThanGenerated ? true : false

    // check if generated documents provides signers
    if (listOfGeneratedDocuments && signerAvailabilityOfTemplates) {
        for (let i = 0; i < listOfGeneratedDocuments.length; i++) {
            let oneDoc = listOfGeneratedDocuments[i]
            let templateId = oneDoc.documentTemplateId

            // extend the languageWhiteList with the values what support the selected template (check html existence in record)
            if (signerAvailabilityOfTemplates && signerAvailabilityOfTemplates.length > 0 && templateId) {
                // find template in the list of all templates
                let signerAvailabilities = signerAvailabilityOfTemplates.filter((item) => {
                    return (item.templateId === templateId)
                })

                let signerAvailability = nesProp.get(signerAvailabilities, "0")

                // see in the console, if the template have no signer configured in the template content.
                if (!signerAvailability) {
                    console.warn("No signer types available for the selected template: ", templateId && templateId._id, "signer types:", signerAvailability)
                }

                if (signerAvailability && signerAvailability.signerTypes) {
                    isItExistFirstSignerPlaceholder = isItExistFirstSignerPlaceholder || signerAvailability.signerTypes[oneDoc.language].includes("CLIENT")
                    isItExistSecondSignerPlaceholder = isItExistSecondSignerPlaceholder || signerAvailability.signerTypes[oneDoc.language].includes("OTHER_PERSON")
                    isItExistBrokerSignerPlaceholder = isItExistBrokerSignerPlaceholder || signerAvailability.signerTypes[oneDoc.language].includes("BROKER")
                }
            }
        }
    }

    // no broker in prem, does not matter anything, -- update BEWB - 706 broker button is now available in prem
    // isItExistBrokerSignerPlaceholder = isItExistBrokerSignerPlaceholder ? (isPrem ? false : true) : false

    return {
        isItExistFirstSignerPlaceholder,
        isItExistSecondSignerPlaceholder,
        isItExistBrokerSignerPlaceholder
    }
}



// WEBPACK FOOTER //
// ./components/DSDocuments/DSWizardHelper.jsx